<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title" >
             {{ "Forecast-Settings" | translate | async }}
        </span>
         <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>

     <div >
    <div class="ttmodal__body">
       <button style="float: right;" mat-raised-button color="warn" type="button" (click)="NavigateTo()">{{ "Preset Forecast Wear Rates" | translate | async }}</button>
         <form [formGroup]="ForecastData" (ngSubmit)="onSubmit()">
       <table class="table table--full-width table--striped" *ngIf="forecastDataVM != null">
          <thead>
            <tr>
              <th>{{"Forecast Selection"  | translate | async}}</th>

              <th class="radio-label"><label for="usage"> {{ "Usage (Hrs)" | translate | async }}</label><input class="forecast-radio-btn" type="radio" id="usage" formControlName="Forecast_Method" value="1" [checked]="hourChecked" (change)="OnUsageRadioValChange(1)"></th>
              <th class="radio-label"><label for="distance">{{ "Distance" | translate | async }}</label><input type="radio" id="distance" class="forecast-radio-btn" formControlName="Forecast_Method" value="2" [checked]="!hourChecked" (change)="OnUsageRadioValChange(2)"></th>
              <th >{{"Forecast Method" | translate | async}}</th>
              <th *ngIf="GetActionType==41"> {{ "Latest SMU/DOE" | translate | async }}</th>
              <th> <mat-form-field class="margin-left-10">
                        <input  matInput  placeholder="{{'Distance Ratio' | translate | async}}"  type="text" formControlName="DistanceRatio"  (input)="limitOneDecimal($event)" ngDefaultControl>
                       </mat-form-field></th>
            </tr>
            <tr>
              <th>{{"Forecast"  | translate | async}}</th>
              <th>{{"Hours"  | translate | async}}</th>
              <!-- <th>{{"Km"  | translate | async}}</th> -->
              <th>{{userUOD | translate | async }}</th>
              <th>
                 <input type="radio" class="forecast-radio-btn" style="margin-left:5px" id="Last3" formControlName="PresetAvg" value="1" (change)="onforecastMethodCalution(1)" [checked]="BoolRadioCheck"> <span class="w-125 margin" >{{ "Average From Last 3 Inspections" | translate | async }}</span>
              </th>
              <th *ngIf="GetActionType==41">Date: {{InspectionForecastPreferenceModel.EventDate | date: 'dd MMM yyyy'}}</th>
              <th>
                <!-- <mat-checkbox class="example-margin" formControlName="show100Worn">Show dates for 100% Worn</mat-checkbox> -->
            </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span class="w-125">{{"System Calculated Usage" | translate | async}}</span> <input type="radio" class="forecast-radio-btn" style="margin-left:5px" id="calculatedUsageHrs" formControlName="Daily_Usage_Calculation_Method" value="1" (change)="onRadioChange(1)" [checked]="calculatedUsaghourChecked"></td>
              <td><span *ngIf="forecastDataVM!=null">{{forecastDataVM.ForecastEntryHours}}</span> hrs</td>
              <td><span *ngIf="forecastDataVM!=null">{{ convertDistanceKmToMi(forecastDataVM.ForecastEntryDistance)}}</span></td>
              <td>
                
                  <input type="radio" class="forecast-radio-btn" style="margin-left:5px" id="presetavg" formControlName="PresetAvg" value="2" (change)="onforecastMethodCalution(2)" [checked]="!BoolRadioCheck"><span class="w-125 margin">Preset Averages</span>
                <!-- <mat-radio-button [value]="2" [checked]="true" (change)="onforecastMethodCalution(2)">Preset Averages</mat-radio-button> -->
              <span style="margin-left: 16px;"><label for="usage">{{ "Safety Factor" | translate | async }}</label> <input type="text" class="input-box" formControlName="SafteyFactor"  style="width:70px"></span>
             <span style="margin-left: 16px;">
                  
                  <label for="usage"> {{ "MidPoint % " | translate | async }}</label> <input type="text"
                    class="input-box" formControlName="MidpointPercentage" style="width:70px">
                  </span>  
            
            </td>
              <td *ngIf="GetActionType==41">{{ "SMU:" | translate | async }} {{InspectionForecastPreferenceModel.Smu}}</td>
              
              <td>
                <!-- <mat-checkbox class="example-margin" formControlName="show120Worn">Show dates for 120% Worn</mat-checkbox> -->
            </td>
            </tr>
            <tr>
              <td>
                <span class="w-125">{{" Manually Entered Usage" | translate | async}}</span> <input type="radio" class="forecast-radio-btn" style="margin-left:5px" id="ManuallyEnteredUsage" formControlName="Daily_Usage_Calculation_Method" value="2" (change)="onRadioChange(2)" [checked]="!calculatedUsaghourChecked">
              </td>
              <td><input type="text" class="input-box" formControlName="Daily_Usage_Hours" (keyup)="onRadioChange(1)"></td>
              <td><input type="text" class="input-box" formControlName="Daily_Usage_Distance" (keyup)="onRadioChange(2)"></td>
              <td>
               <mat-radio-group aria-label="Select an option" formControlName="WeatherType"
                  [disabled]="BoolRadioCheck">
                  <mat-radio-button [value]="1"> {{"Winter" | translate | async}}</mat-radio-button>
                  <mat-radio-button [value]="2"> {{"Summer" | translate | async}}</mat-radio-button>
                  <mat-radio-button [value]="3"> {{"Shoulder" | translate | async}}</mat-radio-button>
                  <mat-radio-button [value]="4"> {{"Other" | translate | async}}</mat-radio-button>
                </mat-radio-group>
                <span *ngIf="ModelMachineLevel" class="font">{{"Machine Level" | translate | async}}</span>
                <span *ngIf="!ModelMachineLevel" class="font">{{"Model Level" | translate | async}}</span>
               </td>
              <td *ngIf="GetActionType==41">{{"DOE:" | translate | async}}{{InspectionForecastPreferenceModel.TotalDistance}}</td>
                            <td>
                                <!-- <mat-checkbox class="example-margin"  formControlName="showLastFourth">Show Last 4th Historical Inspection</mat-checkbox> -->
                            </td>
            </tr>
          </tbody>
        </table>

        <div class="forecast-settings table-container">
        <div class="panel__header">
          <span class="panel__header__title">
            {{ "Forecast Future Service" | translate | async }}
          </span>
        </div>
        <table class="table table--full-width table--striped" *ngIf="forecastDataVM != null">
          <thead>
            <tr style="text-align:center">
              <th >{{"Last Inspection" | translate | async}}</th>
              <th colspan="2" *ngIf="GetActionType==41">Latest SMU</th>
              <th colspan="2">{{"Next PM Service" | translate | async}}</th>
              <th colspan="2">{{"2nd PM Service" | translate | async}}</th>
              <th colspan="2">{{"Floating Date" | translate | async}}</th>
              <th colspan="2">{{"Floating Date 2" | translate | async}}</th>
            </tr>
            <tr>
              <th></th>
              <th *ngIf="GetActionType==41"></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
              <th>{{"Difference" | translate | async}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr style="text-align:center">

              <td>{{forecastDataVM.LastInpectionDate}}</td>
              <td *ngIf="GetActionType==41">{{InspectionForecastPreferenceModel.EventDate | date: 'dd MMM yyyy'}}</td>
              <td>{{dayDiff}}  {{'Days' | translate | async}}</td>

              <td class="date-input">
                <input [matDatepicker]="picker1" placeholder="Choose a date" formControlName="PM_1_Date" (dateChange)="onNextPmDateChange(1)"
                       min="{{_minDateNextPm | date:'yyyy-MM-dd'}}" />

                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>

                <mat-form-field class="date-width">
                                <mat-select placeholder="PM Type" ngDefaultControl [(ngModel)]="forecastDataVM.PmNextServiceType" formControlName="PmNextServiceType">
                                    <mat-option [value]="0">
                                        None
                                    </mat-option>
                                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                        {{customer.TypeName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
              </td>
              <td>{{dayDiff1}}  {{'Days' | translate | async}}</td>

              <td class="date-input">
                <input [matDatepicker]="picker2" placeholder="Choose a date" formControlName="PM_2_Date" (dateChange)="onNextPmDateChange(2)" 
                min="{{_minDateSecoundPm | date:'yyyy-MM-dd'}}" 
                />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>

                 <mat-form-field class="date-width">
                                <mat-select placeholder="Second PM Type" ngDefaultControl [(ngModel)]="forecastDataVM.PmSecondServiceType" formControlName="PmSecondServiceType">
                                    <mat-option [value]="0">
                                        None
                                    </mat-option>
                                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                        {{customer.TypeName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
              </td>
              <td>
                {{dayDiff2}}  {{'Days' | translate | async}}
              </td>
              <td class="date-input">
                <input [matDatepicker]="picker3" placeholder="Choose a date" formControlName="Floating_Date" (dateChange)="onNextPmDateChange(3)"
                min="{{_minDateFlaotingDate1 | date:'yyyy-MM-dd'}}"
                >
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>

                  <mat-form-field class="date-width">
                                <mat-select placeholder="Floating Date 1 Type" ngDefaultControl [(ngModel)]="forecastDataVM.FloatingDate1ServiceType" formControlName="FloatingDate1ServiceType">
                                    <mat-option [value]="0">
                                        None
                                    </mat-option>
                                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                        {{customer.TypeName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
              </td>
              <td>
                {{dayDiff3}}  {{'Days' | translate | async}}
              </td>
              <td class="date-input">
                <input [matDatepicker]="picker4" placeholder="Choose a date" formControlName="Floating_Date2" (dateChange)="onNextPmDateChange(4)"
                min="{{_minDateFlaotingDate2 | date:'yyyy-MM-dd'}}"
                />
                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>

                <mat-form-field class="date-width">
                                <mat-select placeholder="Floating Date 2 PM Type" ngDefaultControl [(ngModel)]="forecastDataVM.FloatingDate2ServiceType" formControlName="FloatingDate2ServiceType">
                                    <mat-option [value]="0">
                                        None
                                    </mat-option>
                                    <mat-option [value]="customer.TypeId" *ngFor="let customer of PmServiceTypes">
                                        {{customer.TypeName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
              </td>
              
            </tr>
            <tr style="text-align:center">

              <td>{{ "SMU:" | translate | async }}  {{forecastDataVM.LastinspectionSMU | number: '1.0-0'}}</td>
              <td *ngIf="GetActionType==41">{{ "SMU" | translate | async }}  {{InspectionForecastPreferenceModel.Smu | number: '1.0-0'}}</td>
              <td>
                {{diffBetweenLastandPreviousInpectionUsgHours1  | number:'1.0-0'}} {{ "Hrs" | translate | async }}
              </td>
              <td>{{ "SMU:" | translate | async }}  {{NextPMSMU | number: '1.0-0'}} </td>
              <td>
                {{diffBetweenLastandPreviousInpectionUsgHours2 | number:'1.0-0'}} {{ "Hrs" | translate | async }}
              </td>
              <td>{{ "SMU:" | translate | async }}  {{SecondPMSMU | number: '1.0-0'}}</td>
              <td>
                {{diffBetweenLastandPreviousInpectionUsgHours3 | number:'1.0-0'}} {{ "Hrs" | translate | async }}
              </td>
              <td> {{ "SMU:" | translate | async }}  {{FloatingSMU | number: '1.0-0'}}</td>
              <td> {{diffBetweenLastandPreviousInpectionUsgHours4 | number:'1.0-0'}} {{ "Hrs" | translate | async }}</td>
              <td> {{ "SMU:" | translate | async }}  {{FloatingSMU2 | number: '1.0-0'}}</td>
              <td> </td>
            </tr>
            <tr style="text-align:center">
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(forecastDataVM.LastInspectionDistance) | number : '1.0-0'}}</td>
              <td *ngIf="GetActionType==41">{{ "DOE" | translate | async }} {{ convertDistanceKmToMi(InspectionForecastPreferenceModel.TotalDistance) | number : '1.0-0'}}</td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance1) | number : '1.0-0'}} {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(NextPmDistance) | number : '1.0-0'}} </td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance2) | number : '1.0-0'}} {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(SecondDistance) | number : '1.0-0'}}</td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance3) | number : '1.0-0' }} {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(FloatingDistance) | number : '1.0-0'}} </td>
              <td>{{ convertDistanceKmToMi(diffBetweenLastandPreviousInpectionDistance4) | number : '1.0-0'}} {{userUOD}}</td>
              <td>{{ "DOE:" | translate | async }} {{ convertDistanceKmToMi(FloatingDistance2) | number : '1.0-0'}} </td>
              <td></td>
            </tr>


          </tbody>

        </table>
        <div class="flex flex--align-center bottom-row" style="justify-content: end !important;">
          <div class="marginright10">
            <!-- <button mat-raised-button class="button" (click)="ResetFields()" type="button">Reset</button> -->
          </div>
          <div style="margin-bottom: 5px;">
            <button mat-icon-button (click)="OnRefresh()" >
            <mat-icon style="color: green;">refresh</mat-icon>
          </button>
            <button mat-raised-button color="warn"  type="submit">Save</button>
          </div>
        </div>
      </div>
        </form>
    </div>
    <!-- <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="">
        Save
      </button>
    </div> -->
  </div>
</div>